// This code exports three arrays of data, projects, testimonials, and skills,
// that will be used in other parts of the application.

// The projects array contains objects that represent different projects, 
// each with properties such as title, subtitle, description, image and link.

export const projects = [
  {
    title: "React Reserve",
    subtitle: "MERN Stack",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-1.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "React Tracks",
    subtitle: "React and Python",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-2.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "DevChat",
    subtitle: "React and Firebase",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-3.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-4.gif",
    link: "https://reactbootcamp.com",
  },
];

// The testimonials array contains objects that represent different testimonials,
// each with properties such as quote, image, name, and company.

export const testimonials = [
  {
    quote:
      "Robert is an exceptional customer success manager and implementation specialist with internetworking abilities and python scripting development that are key to director-level success in market access and healthcare reimbursement. He consistently boosts productivity in remote work environments with his solutions-oriented approach. I highly recommend him as a technical advisor and problem solver.",
    image: "https://i.imgur.com/dobUObe.jpg",
    name: "Alicia R",
    company: "Director Of Healthcare Reimburstment & Market Access",
  },
  {
    quote:
      "If you need a remote desktop solutions pro, look no further than Robert. He's a real TwinGate whiz and knows how to make file access seamless, even when you're not in the office. He also introduced me to a game-changing Plex SSD cloud solution that kept me productive and on top of my work. If you're looking for a tech-savvy problem-solver, Robert's your man.",
    image: "https://imgur.com/2VmACCz.png",
    name: "Kevin Jensen",
    company: "Graphic Designer -Mixer",
  },
];

// The skills array is a simple array of strings, each representing a skill.
export const skills = [
  "JavaScript",
  "Project Management",
  "Python",
  "React",
  "Onboarding",
  "APIs",
  "QBRs/EBRs",
  "Node",
  "PostgreSQL",
  "Contract Renewals",
  "Express",
  "Relationship Management",
];



// WEBPACK FOOTER //
// ./src/data.js